export default __webpack_public_path__ + "static/media/lactose-free.e08b0c0e.png";